/* Dalen — Article page Related Products slider.
   Adapted from dalen-popular-scroller.js but scoped to the slider inside
   the article sidebar (.dalen-article__product-slider). Hides Dawn's
   below-slider control bar, injects custom rounded-square arrows and
   orange dot pagination, and proxies clicks to Dawn's prev/next so all
   the scroll/snap/disabled-state logic continues to work. */
(function () {
  var ARROW_RIGHT = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M1 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_LEFT  = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" style="transform:scaleX(-1)"><path d="M1 8h12M8 3l5 5-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initOne(sliderComp) {
    if (!sliderComp || sliderComp.dataset.dalenArticleInit) return;
    var slider   = sliderComp.querySelector('.slider');
    var slides   = sliderComp.querySelectorAll('[id^="Slide-"]');
    var dawnPrev = sliderComp.querySelector('.slider-button--prev');
    var dawnNext = sliderComp.querySelector('.slider-button--next');
    if (!slider || !slides.length) return;
    sliderComp.dataset.dalenArticleInit = 'true';

    // ---- Custom side arrows ----
    sliderComp.querySelectorAll('.dalen-article__arrow').forEach(function (n) { n.remove(); });

    function buildArrow(direction) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dalen-article__arrow dalen-article__arrow--' + direction;
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
      btn.innerHTML = direction === 'prev' ? ARROW_LEFT : ARROW_RIGHT;
      btn.addEventListener('click', function () {
        var target = direction === 'prev' ? dawnPrev : dawnNext;
        if (target) {
          // Related Products: proxy to Dawn's (hidden) prev/next so its
          // scroll/snap/paging logic runs.
          if (!target.hasAttribute('disabled')) target.click();
        } else {
          // Related Posts (no Dawn buttons) — scroll the track directly by
          // one slide.
          var first = slides[0], second = slides[1];
          var step = (first && second) ? (second.offsetLeft - first.offsetLeft) : slider.clientWidth;
          slider.scrollBy({ left: direction === 'prev' ? -step : step, behavior: 'smooth' });
        }
      });
      return btn;
    }

    var prevBtn = buildArrow('prev');
    var nextBtn = buildArrow('next');
    sliderComp.appendChild(prevBtn);
    sliderComp.appendChild(nextBtn);

    function syncArrowState() {
      // Compute disabled state directly from scroll position so it's correct
      // on first paint, even before Dawn's slider-component finishes its
      // initPages() / update() cycle (which can race with our init on slow
      // devices and leave both arrows greyed out until the user interacts).
      var atStart = slider.scrollLeft <= 1;
      var atEnd   = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
      prevBtn.toggleAttribute('disabled', atStart);
      nextBtn.toggleAttribute('disabled', atEnd);
    }
    syncArrowState();
    // Re-run after the layout settles — clientWidth/scrollWidth can be 0 or
    // too small for a frame (before images/fonts size the slides), which
    // would wrongly disable the "next" arrow on first paint until the user
    // interacts. Re-sync across several points to cover slow layouts.
    requestAnimationFrame(syncArrowState);
    setTimeout(syncArrowState, 100);
    setTimeout(syncArrowState, 300);
    setTimeout(syncArrowState, 700);
    // Images changing the slider's scrollable width is the main culprit —
    // re-sync as each finishes loading, and once the whole page has loaded.
    sliderComp.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', syncArrowState, { once: true });
        img.addEventListener('error', syncArrowState, { once: true });
      }
    });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', syncArrowState, { once: true });
    }

    function computeTotalPages() {
      if (slides.length < 2) return slides.length;
      var first  = slides[0];
      var second = slides[1];
      var offset = second.offsetLeft - first.offsetLeft;
      if (!offset) return slides.length;
      var slidesPerPage = Math.round((slider.clientWidth - first.offsetLeft) / offset);
      return Math.max(1, slides.length - slidesPerPage + 1);
    }

    function buildDots(totalPages) {
      var existing = sliderComp.querySelector('.dalen-article__dots');
      if (existing) existing.remove();
      if (totalPages < 2) return null;

      var container = document.createElement('div');
      container.className = 'dalen-article__dots';
      container.setAttribute('role', 'tablist');
      container.setAttribute('aria-label', 'Slide navigation');

      var dots = [];
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dalen-article__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('role', 'tab');
        dot.dataset.page = String(i + 1);
        dot.addEventListener('click', onDotClick);
        dots.push(dot);
        container.appendChild(dot);
      }
      sliderComp.appendChild(container);
      return { container: container, dots: dots };
    }

    function onDotClick(e) {
      var page = parseInt(e.currentTarget.dataset.page, 10);
      var target = slides[page - 1];
      if (!target) return;
      slider.scrollTo({
        left: target.offsetLeft - slides[0].offsetLeft,
        behavior: 'smooth'
      });
    }

    var built = buildDots(computeTotalPages());
    var dots  = built ? built.dots : [];

    // Scroll-based active-dot sync — works even when Dawn's SliderComponent
    // never initialises (e.g. Related Posts, which has no next button) and so
    // never fires the slideChanged event.
    function syncDots() {
      if (!dots.length) return;
      var first = slides[0], second = slides[1];
      var offset = (first && second) ? (second.offsetLeft - first.offsetLeft) : 0;
      if (!offset) return;
      var cur = Math.round(slider.scrollLeft / offset);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
    }

    sliderComp.addEventListener('slideChanged', function (e) {
      var current = e.detail && e.detail.currentPage;
      if (current && dots.length) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i + 1 === current); });
      }
      syncArrowState();
    });

    slider.addEventListener('scroll', function () {
      requestAnimationFrame(function () { syncArrowState(); syncDots(); });
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var next = computeTotalPages();
        if (next === dots.length) return;
        var rebuilt = buildDots(next);
        if (rebuilt) dots = rebuilt.dots;
      }, 200);
    });
  }

  function init() {
    document.querySelectorAll('.dalen-article__product-slider').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.dalen-article__product-slider')) {
      e.target.querySelectorAll('.dalen-article__product-slider').forEach(function (sc) {
        delete sc.dataset.dalenArticleInit;
      });
      init();
    }
  });
})();
